// --- NOVO: Declaramos a variável do observador aqui fora, para que possamos acessá-la e limpá-la.
let sectionObserver = null;

const loadItems = (button) => {
	// Pega a URL *completa e correta* do input na página
	const nextUrl = $("[data-next-url]").val();

	// Se não houver URL, significa que chegamos ao fim. Não faz nada.
	if (!nextUrl) {
		if(button) button.remove();
		return;
	}

	// Desabilita o botão/spinner para evitar chamadas múltiplas enquanto uma já está em andamento
	if(button) {
		button.setAttribute("disabled", "");
		button.classList.add("loading");
	}

	$.ajax({
		url: nextUrl, // Usa a URL correta, sem modificá-la
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			const newContent = $(responseHTML);
			const newProductsHTML = newContent.find(".load-more-grid").html();

            // Verifica se vieram produtos novos para evitar adicionar conteúdo vazio
            if (newProductsHTML && newProductsHTML.trim().length > 0) {
                $(".load-more-grid").append(newProductsHTML);

                const newNextUrl = newContent.find("[data-next-url]").val();
                const newCurrentPage = newContent.find("[data-current-page]").val();

                if (newNextUrl) {
                    $("[data-next-url]").val(newNextUrl);
                    $("[data-current-page]").val(newCurrentPage);
                } else {
                    $("[data-next-url]").val('');
                }
            } else {
                // Se não vieram produtos, consideramos que foi a última página
                $("[data-next-url]").val('');
            }
            
			try {
				if (typeof colorSwatches === 'function') colorSwatches();
			} catch (err) {}
		},
		complete: function () {
			if(button) {
				button.removeAttribute("disabled");
				button.classList.remove("loading");
			}
			
			if (!$("[data-next-url]").val()) {
				if(button) button.remove();
                if (sectionObserver) sectionObserver.disconnect(); // Desconecta o observador se acabaram as páginas
			} else {
                // Reativa a verificação de visibilidade para o próximo carregamento
                checkVisibility();
            }
		},
        error: function() {
            if(button) {
                button.removeAttribute("disabled");
			    button.classList.remove("loading");
            }
            console.error("Erro ao carregar mais produtos.");
        }
	});
};

const checkVisibility = () => {
	// --- MODIFICADO: Desconecta o observador antigo antes de criar um novo
	if (sectionObserver) {
		sectionObserver.disconnect();
	}

	const spinner = document.querySelector(".js-infinite-scroll");
    
    // Se o spinner não existe mais (ex: já carregou tudo), não faz nada
    if (!spinner) {
        return;
    }
    
	sectionObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
                // --- MODIFICADO: Desconecta imediatamente para não disparar de novo por acidente
                sectionObserver.disconnect(); 
				loadItems(spinner);
			}
		});
	});

	sectionObserver.observe(spinner);
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = (e) => {
            e.preventDefault();
			loadItems(button);
		};
	});

	checkVisibility();
}

(function () {
	loadMore();
})();